import { Box } from '@mui/system'
import React from 'react'

const SubcategoryHintBox: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Box
      sx={theme => ({
        backgroundColor: theme.palette.grey.grey07,
        border: '1px solid',
        borderColor: theme.palette.grey.grey06,
        borderRadius: 2,
        p: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      })}
    >
      {children}
    </Box>
  )
}

export default SubcategoryHintBox
